(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pd-category-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const attach = (section) => {
      if (section.dataset.pdScroller) return;

      const row = section.querySelector('.pd-category-grid__grid');
      const prev = section.querySelector('[data-pd-scroll="prev"]');
      const next = section.querySelector('[data-pd-scroll="next"]');
      if (!row || !prev || !next) return;

      section.dataset.pdScroller = 'on';

      // Step by just under a full view, so the card at the edge stays visible
      // and the reader keeps their place instead of jumping a clean page.
      const step = () => Math.max(240, row.clientWidth * 0.8);

      const behavior = () =>
        window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

      const update = () => {
        const max = row.scrollWidth - row.clientWidth - 1;
        prev.disabled = row.scrollLeft <= 0;
        next.disabled = row.scrollLeft >= max;
      };

      prev.addEventListener('click', () => row.scrollBy({ left: -step(), behavior: behavior() }));
      next.addEventListener('click', () => row.scrollBy({ left: step(), behavior: behavior() }));

      // Kept in sync however the row moves — arrows, trackpad, touch or resize.
      row.addEventListener('scroll', update, { passive: true });
      new ResizeObserver(update).observe(row);
      update();
    };

    const scan = () => {
      for (const section of document.querySelectorAll('.pd-category-grid--scroller')) attach(section);
    };

    scan();
    document.addEventListener('DOMContentLoaded', scan);
    document.addEventListener('shopify:section:load', scan);
  })();

  } catch(e) { console.error(e); }
})();
})();
